// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update_constants`

export const IMAGE_VERSION = "15";
